<template>
    <div>
      <slot/>
    </div>
  </template>
  

  <style>
     #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        background-color: #f2f2f2;
        color: #111;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 55px;
        padding-top: 0px;
      }
  </style>
  